export default __webpack_public_path__ + "static/media/servicedata.53370c3d.png";